export default __webpack_public_path__ + "static/media/game-fallback.538ef78d.png";